<template>
  <v-container fluid class="pa-0">
    <v-card :loading="true" v-if="machine == null">
      <v-card-title>{{ $t("text.loading") }}</v-card-title>
    </v-card>
    <v-card v-else :loading="loading" flat>
      <v-list class="py-0">
        <v-list-item v-for="item in documents" :key="item.Id" @click="showItem(item)" dense
          style="border-top: 1px solid #dddddd;">
          <div class="v-list-item-icon my-auto mr-3">
            <v-icon>
              {{ getDocumentTypeIcon(item.DocumentType_Id) }}
            </v-icon>
          </div>
          <div class="v-list-item-content">
            <v-list-item-title>{{ item.Name }}</v-list-item-title>
          </div>
          <div class="v-list-item-action my-auto">
            <v-btn color="primary">{{ $t("text.open") }}</v-btn>
          </div>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>


<script>
import http from "@/api/client";

export default {
  name: "CustomerMachineManualsPanel",

  props: {
    machine: { type: Object, default: null },
  },

  data() {
    return {
      documents: null,
      loading: false,
    };
  },

  mounted() {
    if (this.machine) this.updateManuals(this.machine);
    else this.$emit("updateMachine");
  },

  methods: {
    showItem(item) {
      window.open(item.LinkUrl, "_blank");
    },
    getDocumentTypeIcon(documentTypeId) {
      switch (documentTypeId) {
        case 1:
          return "mdi-file-pdf";
        default:
          return "mdi-file";
      }
    },
    updateManuals(machine) {
      if (machine) {
        this.loading = true;
        http()
          .get("api2/customer/documents/forms/" + machine.Id)
          .then((response) => {
            this.documents = response.data;
            this.loading = false;
          });
      }
    },
  },

  computed: {},

  watch: {
    machine(val) {
      this.updateManuals(val);
    },
  },
};
</script>


<style scoped>
.highlighted {
  background-color: var(--v-secondary-base) !important;
}
</style>